import { State, IProjectState } from 'store';

const initialProjectState: IProjectState = {
  usersAsync: { status: 'INIT' },
  runsAsync: { status: 'INIT' },
  runDetailsAsyncMap: {},
  runFilesAsyncMap: {},
  taskDetailsAsyncMap: {},
  workflowDefinitionsAsync: { status: 'INIT' },
  workflowDefinitionDetailsAsyncMap: {},
};

export default function getProjectState(
  state: State,
  projectId: string | undefined,
): IProjectState {
  if (!projectId) return initialProjectState;
  return state.projectStateMap[projectId] || initialProjectState;
}
